import { GetCustomEventsResponseBodyType } from "@intelligems/ig-types";
import { customEventsKeys } from "@src/api/queryKeys";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";

const getAllCustomEvents = async () => {
  const resp =
    await api.get<GetCustomEventsResponseBodyType>("/v2/custom-events");
  return resp.data;
};

export const useGetAllCustomEvents = () => {
  return useQuery<GetCustomEventsResponseBodyType>({
    queryKey: customEventsKeys.all,
    queryFn: async () => getAllCustomEvents(),
  });
};
